import { Link } from '@healthinal/ui';
import { DataItem } from './DataItem';

interface Props {
  email: string | null | undefined;
}

export function PracticeEmailDataItem({ email }: Props) {
  if (!email) {
    return null;
  }
  return (
    <DataItem label="Praxis E-Mail">
      <Link href={`mailto:${email}`}>{email}</Link>
    </DataItem>
  );
}
